import React from 'react';
import StockLiteList from './StockLiteList';
import usePlatformConfig from '../../../common/react/usePlatformConfig';
import { StockVersionTypes } from '../../../gqlCommon/enum/StockVersionTypes';
import useSalesEnablementContext from '../../../gqlCommon/hooks/useSalesEnablementContext';

const StockLiteListContainer = () => {
  const {
    platformConfig: { stockVersion },
  } = usePlatformConfig();
  const { initializedWithStock } = useSalesEnablementContext();

  return stockVersion !== StockVersionTypes.NONE && !initializedWithStock ? <StockLiteList /> : null;
};

export default StockLiteListContainer;
